import { UploadRawFile } from 'element-plus'
// import SparkMD5 from 'spark-md5'

type MD5MessageType = {
  file?: UploadRawFile;
  uid: number;
  cancel?: boolean;
};
// 正在处理的文件记录，当值为 false 时，表示被终止了。
const progressingFilesMap = new Map<number, boolean>()
/**
 * 获取文件MD5，采用分片的模式读取文件，最后合并生成 MD5
 * @param file
 * @returns {Promise<unknown>}
 */
// export const getFileMd5 = (file: UploadRawFile, uid: number) => {
//   const fileReader = new FileReader()
//   const chunkSize = 1024 * 1024 // 分片大小
//   const chunks = Math.ceil(file.size / chunkSize) // 总分片数
//   const updateProgress = getProgress(chunks, uid)

//   let currentChunk = 0
//   // const spark = new SparkMD5()

//   progressingFilesMap.set(uid, true)

//   return new Promise((resolve, reject) => {
//     fileReader.onload = (e) => {
//       spark.appendBinary(e.target!.result as string) // append binary string

//       updateProgress(++currentChunk)

//       if (progressingFilesMap.get(uid) === false) {
//         // 被终止，则移除
//         progressingFilesMap.delete(uid)
//         reject(new Error('Be cancelled'))
//       } else if (currentChunk < chunks) {
//         // 未结束，则处理下一个分片
//         loadNext()
//       } else {
//         // 处理完成
//         progressingFilesMap.delete(uid)
//         resolve(spark.end())
//       }
//     }
//     fileReader.onerror = (e) => {
//       reject(e)
//     }

//     const loadNext = () => {
//       const start = currentChunk * chunkSize
//       const end = start + chunkSize >= file.size ? file.size : start + chunkSize
//       fileReader.readAsBinaryString(file.slice(start, end))
//     }

//     loadNext()
//   })
// }

/**
 * 生成进度
 * @param totalChunk 总片数
 * @param uid 文件的 uid
 * @returns 更新进度，参数 processedChunk 为已处理的分片数
 */
const getProgress = (totalChunk: number, uid: number) => {
  let preTime = 0
  let percent = 0

  return (processedChunk: number) => {
    const now = Date.now()
    // 控制触发间隔大于 500 毫秒
    // 当已经结束，就马上触发
    if (now - preTime > 500 || processedChunk >= totalChunk) {
      percent = Math.min(1, processedChunk / totalChunk) * 100
      percent = parseFloat(percent.toFixed(1))
      // 发送进度通知
      self.postMessage({
        status: 'progress',
        uid,
        percent
      })
      preTime = now
    }
  }
}
// 判断是否为移动端设备
 export function isMobileDevice() {
   const userAgent = navigator.userAgent || navigator.vendor;
   // 检测是否为移动设备的正则表达式
   return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|windows phone/i.test(userAgent);
 }

// 胜平负代码转换为中文  hadf 胜平负 hhadf 让球胜平负 ttgf 进球数 hafuf 半全场 crsf 比
export function code2zh (codeArray: string[], hasSp: boolean, match: any, type: string) {
  // eslint-disable-next-line no-debugger
  // debugger

  const codeMap: { [key: string]: { [key: string]: string } } = {
    hadMap: {
      h: '胜',
      d: '平',
      a: '负'
    },
    hhadMap: {
      h: '让胜',
      d: '让平',
      a: '让负'
    },
    hafuMap: {
      hh: '胜胜',
      hd: '胜平',
      ha: '胜负',
      dh: '平胜',
      dd: '平平',
      da: '平负',
      ah: '负胜',
      ad: '负平',
      aa: '负负'
    },
    ttgMap: {
      s0: '0球',
      s1: '1球',
      s2: '2球',
      s3: '3球',
      s4: '4球',
      s5: '5球',
      s6: '6球',
      s7: '7+球'
    },
    crsMap: {
      s01s00: '1:0',
      s02s00: '2:0',
      s02s01: '2:1',
      s03s00: '3:0',
      s03s01: '3:1',
      s03s02: '3:2',
      s04s00: '4:0',
      s04s01: '4:1',
      s04s02: '4:2',
      s05s00: '5:0',
      s05s01: '5:1',
      s05s02: '5:2',
      s1sh: '胜其它',
      s00s00: '0:0',
      s01s01: '1:1',
      s02s02: '2:2',
      s03s03: '3:3',
      s1sd: '平其它',
      s00s01: '0:1',
      s00s02: '0:2',
      s01s02: '1:2',
      s00s03: '0:3',
      s01s03: '1:3',
      s02s03: '2:3',
      s00s04: '0:4',
      s01s04: '1:4',
      s02s04: '2:4',
      s00s05: '0:5',
      s01s05: '1:5',
      s02s05: '2:5',
      s1sa: '负其它'
    }
  }
  console.log(codeArray)
  return codeArray.map(code => {
    // eslint-disable-next-line no-debugger
    // debugger
    if (1 && hasSp) {
      return `${codeMap[`${type}Map`][code]}@${match[type][code]}`
    }
    return codeMap[`${type}Map`][code]
  }).join('/')
}
export function splitRes (resStr: string) {
  console.log(resStr)
  const resList = resStr.split('/')
  const strList:string[] = []
  const spList: number[] = []
  resList.forEach(item => {
    const [s, n] = item.split('@')
    strList.push(s)
    spList.push(Number(n))
  })
  return {
    str: strList.join('/'),
    sp: spList.reduce((accumulator, currentValue) => accumulator + currentValue, 0) / 4
  }
}

export { lightenRgb } from './leagueColor'

/**
 * 压缩图片文件
 * @param {File} file - 原始图片文件
 * @param {Object} options - 压缩选项
 * @param {number} [options.quality=0.8] - 压缩质量，必须在0-1之间，值越大质量越高，1表示最高质量
 * @param {number} [options.maxWidth=1920] - 最大宽度，超过则按比例缩小
 * @param {number} [options.maxHeight=1080] - 最大高度，超过则按比例缩小
 * @param {string} [options.mimeType='image/jpeg'] - 输出图片格式
 * @returns {Promise<File>} 压缩后的图片File对象
 */
export function compressImage(file: File, options = {}) {
  // 默认配置
  const defaultOptions = {
    quality: 0.6,
    maxWidth: 2600,
    maxHeight: 10000,
    mimeType: file.type.startsWith('image/png') ? 'image/png' : 'image/jpeg'
  };

  // 合并配置
  let { quality, maxWidth, maxHeight, mimeType } = { ...defaultOptions, ...options };

  // 验证quality参数，确保在0-1之间
  if (typeof quality !== 'number' || quality < 0 || quality > 1) {
    console.warn('压缩质量参数必须在0-1之间，已使用默认值0.8');
    quality = 0.5;
  }

  return new Promise((resolve, reject) => {
    // 检查文件是否为图片
    if (!file.type.startsWith('image/')) {
      reject(new Error('请传入图片文件'));
      return;
    }

    // 创建图片对象
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = function() {
      // 释放object URL
      URL.revokeObjectURL(objectUrl);

      // 计算压缩后的尺寸（保持比例）
      let width = img.width;
      let height = img.height;

      // 如果图片尺寸超过最大限制，按比例缩小
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = width * ratio;
        height = height * ratio;
      }

      // 创建canvas元素
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 设置canvas尺寸
      canvas.width = width;
      canvas.height = height;

      // 在canvas上绘制图片
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
      } else {
        reject(new Error('无法获取canvas的2D绘图上下文'));
      }

      // 特殊处理PNG格式，使用更高的默认质量以保持透明度
      const finalQuality = mimeType === 'image/png' && typeof quality === 'undefined' ? 1 : quality;

      // 将canvas内容转换为Blob
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('图片压缩失败'));
            return;
          }

          // 将Blob转换为File对象
          const compressedFile = new File(
            [blob],
            file.name,
            { type: mimeType, lastModified: Date.now() }
          );

          resolve(compressedFile);
        },
        mimeType,
        finalQuality
      );
    };

    img.onerror = function() {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('图片加载失败'));
    };

    // 加载图片
    img.src = objectUrl;
  });
}
